import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const { preloadDataSuccess } = isOfflineDev ? await import("../tests/fixtures/preloadData") : {};
const { locationsSuccess } = isOfflineDev ? await import("../tests/fixtures/locations") : {};

export async function getAllLocations(headers) {
  if (import.meta.env.VITE_OFFLINE_DEV !== "true") {
    let tokenData = await fetchCurrentUserData()
    headers = { ...headers, ...tokenData }
    return fetch(BACKEND_API_PLACEHOLDER + '/api/siteTrackPreload/location/all', {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return locationsSuccess
}

export async function getTeamsForSites(employeeSites, headers) {
  if (import.meta.env.VITE_OFFLINE_DEV !== "true") {
    let url = BACKEND_API_PLACEHOLDER + "/api/siteTrackPreload/sites_teams"
    for (let i = 0; i < employeeSites.length; i++) {
      if (i === 0) url += `?siteId=${employeeSites[i]}`
      else url += `&siteId=${employeeSites[i]}`
    }
    let tokenData = await fetchCurrentUserData()
    headers = {
      ...headers,
      ...tokenData
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return {}
}

export async function getSiteTrackPreload(headers) {
  if (import.meta.env.VITE_OFFLINE_DEV !== "true") {
    let tokenData = await fetchCurrentUserData()
    headers = { ...headers, ...tokenData }
    return fetch(BACKEND_API_PLACEHOLDER + '/api/siteTrackPreload', {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return preloadDataSuccess
}